import { cn } from '../../../lib/styles';
import type { PressableProps, PressableType } from './types';

export type PressableSkin = {
  rounded: Record<PressableType, string>;
  /** Focus ring and hover fill — where the platform's design language shows. */
  interaction: string;
};

/**
 * The plain `<button>` trigger, for platforms without a native clickable primitive.
 * Geometry and ARIA are fixed; each platform supplies its own `skin`.
 */
export function PressableBase({
  children,
  onClick,
  type = 'default',
  fullWidth = false,
  fullHeight = false,
  disabled = false,
  ariaExpanded,
  ariaControls,
  ariaLabel,
  skin,
}: PressableProps & { skin: PressableSkin }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-label={ariaLabel}
      className={cn(
        skin.rounded[type],
        fullWidth && 'w-full',
        fullHeight && 'flex h-full',
        'cursor-pointer appearance-none border-none bg-none transition disabled:cursor-not-allowed',
        skin.interaction,
      )}
    >
      {children}
    </button>
  );
}
